// Module
var code = "<div class=\"js-screen-brokerinfo\">\r\n    <terceraPictureBox imageUrl=\"{{.imageUrl}}\" component_style=\"js-brand-image\" />\r\n    <div class=\"js-broker-info-text\"></div>\r\n</div>";
// Exports
export default code;